import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74117fd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-bottom d-flex justify-content-between pb-4 mb-4 -p-1 align-items-start" }
const _hoisted_2 = { class: "user d-flex align-items-center" }
const _hoisted_3 = { class: "d-flex align-items-center fs-7 fw-bold" }
const _hoisted_4 = { class: "text-break" }
const _hoisted_5 = {
  key: 0,
  class: "fs-8 date-text"
}
const _hoisted_6 = {
  key: 1,
  class: "fs-8 date-text"
}
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "content__main pb-4" }
const _hoisted_9 = {
  key: 0,
  class: "fw-bold mb-4 fs-9 ps-5 ps-lg-0 text-break"
}
const _hoisted_10 = {
  key: 1,
  class: "ql-snow"
}
const _hoisted_11 = { class: "ql-editor only-view-editor no-padding" }
const _hoisted_12 = ["src", "data-bs-target", "width", "height"]
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_17 = { class: "ql-snow" }
const _hoisted_18 = ["id"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 2,
  class: "d-flex flex-column mb-4 border-top border-bottom mt-4 py-0"
}
const _hoisted_21 = {
  key: 3,
  class: "d-flex flex-column align-items-center justify-content-center mb-lg-5 mb-3"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "my-5 fw-bold fs-9" }, "プロフィールを更新しました。", -1))
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "d-flex flex-column" }
const _hoisted_25 = {
  key: 0,
  class: "flex ml-auto mb-4"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-button-text" }, "詳しくはこちら", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "circle-button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" })
], -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-button-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-button-text" }, "詳しくはこちら"),
  /*#__PURE__*/_createElementVNode("button", { class: "circle-button" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" })
  ])
], -1))
const _hoisted_32 = {
  key: 1,
  class: "mb-4 d-flex flex-wrap m-20"
}
const _hoisted_33 = { class: "d-flex flex-wrap" }
const _hoisted_34 = {
  key: 2,
  class: "d-flex btn-container justify-content-sm-end mb-4"
}
const _hoisted_35 = {
  key: 3,
  class: "d-flex justify-content-end mb-4"
}
const _hoisted_36 = {
  key: 4,
  class: "file-container d-flex justify-content-between align-items-center"
}
const _hoisted_37 = { class: "d-flex align-items-center text-truncate" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_39 = { class: "mb-0 text-truncate" }

import { computed, ComputedRef, PropType, ref, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'
import TargetTag from '@/components/target-tag/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Category from '@/components/category/index.vue'
import HashTag from '@/components/hash-tag/index.vue'
import LikeButton from '@/components/like-button/index.vue'
import Comment from '@/views/shared/communities/components/Comment.vue'
import Avatar from '@/components/avatar/index.vue'
import FlagIcon from '@/components/flag-icon/index.vue'
import UserComments from '@/views/shared/communities/components/UserComments.vue'
import Submenu from '@/components/submenu/index.vue'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import ModalZoomImage from '@/views/shared/communities/components/ModalZoomImage.vue'
import { translate } from '@/languages/i18n'
import PostFileDownload from '@/views/shared/communities/components/PostFileDownload.vue'
import { addPostParams } from '@/use/usePath'

import { ACCOUNT_STORE, COMMUNITY_STORE, POST_STORE } from '@/store/constants'
import { ROOT_STORE } from '@/store/constants'
import { PostType } from '@/store/modules/post'

import { onMounted } from 'vue-demi'
import { ChangeTime } from '@/constants/datepicker'
import userPostService from '@/services/user-post.services'
import { useRoute } from 'vue-router'
import { LIST_USER_NAME, POST_TYPE } from '@/constants/common'
import 'vue-toastification/dist/index.css'
import { useToast } from 'vue-toastification'
import communitySitePostDeleted from '@/components/toast-error/communitySitePostDeleted.vue'
import { isEmpty } from 'lodash'
import UrlDisplay from '@/components/post-url/UrlDisplay.vue'

import { countCharInSurrogatePair, escapeHtml, generateString, getUnicodeLength, isSaasTypePool, sliceUnicode } from '@/utils'
import { editorTrimBottomOnlyNewLine } from '@/views/community-admin/community-site/constants'
import { EDITOR_EMPTY_TAG_REGEX } from '@/constants/regex'
import { purifyContent } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  post: {
    type: Object as PropType<PostType>,
    required: true,
  },
  handleLikeOrInterest: {
    type: Function as PropType<() => void | undefined>,
  },
  ref: null,
  loadingLike: Boolean,
  handleInterestClick: {
    type: Function as PropType<(p: PostType) => void | undefined>,
    required: true,
  },
  isNotLoadingPostSkeleton: {
    type: Boolean,
    default: false,
  },
  listUser: {
    type: Array,
  },
  id_comment: {
    type: String,
    default: null,
  },
},
  emits: ['setCurrentPost', 'setCommentData', 'showDeleteCommentModal'],
  setup(__props, { emit }) {

const props = __props



const modal = ref()

const store = useStore()
const toast = useToast()

const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const users = computed(() => store.getters[POST_STORE.GETTERS.LIST_USER_MENTION_POST])
const listUserShow = computed(() => props.listUser)
const mentionUsers = computed(() => LIST_USER_NAME(users.value?.data, users.value))
const postType = computed(() => store.getters[POST_STORE.GETTERS.GET_POST_TYPE])

const storeSaasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])

const observerPost = ref()
const viewPost = ref<HTMLElement>()
const post_content = ref<HTMLElement>()
const seeMoreBtn = ref<string>(0)
const fullContent = ref<boolean>(false)
const divId = ref<string>('')

const communitySitePostContent = computed(() => {
  if (props.post.content_type === 5) {
    return getCommunitySiteContent(props?.post?.content)
  } else {
    return {}
  }
})

const route = useRoute()

watch(
  () => props.post,
  async () => {
    await nextTick()
    seeMoreBtn.value = post_content.value?.offsetHeight

    if (props.post?.content_type === 5) {
      setTimeout(() => {
        const linkableComponents = document.querySelectorAll(`#post-content-container-${divId.value ?? 0} a`)
        linkableComponents.forEach((linkableComponent) => {
          linkableComponent.setAttribute('target', '_blank')
        })
      }, 300)
    }
  },
  {
    deep: true,
    immediate: true,
  }
)



const setCommentData = (post_id, id, published) => {
  emit('setCommentData', post_id, id, published)
}

const showDeleteCommentModal = () => {
  emit('showDeleteCommentModal')
}

onMounted(() => {
  divId.value = generateString(10)
  observerPost.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      const queryData = {
        post_id: props?.post?.id,
      }
      userPostService.getPostsAnalytics(queryData)
    }
  })
  if (viewPost.value) {
    observerPost?.value.observe(viewPost.value)
  }
  window.addEventListener('hidden.bs.modal', function () {
    enableScrollModal()
  })
})

onMounted(async () => {
  // Show full content post if page is details
  if (postType.value === POST_TYPE.DETAILS) {
    fullContent.value = true
  }
  if (storeSaasType.value && !isSaasTypePool(storeSaasType.value)) {
    await store.dispatch(POST_STORE.ACTIONS.GET_USER_MENTION_POST, { post_id: props?.post?.id })
  }
})

const ua = window.navigator.userAgent.toLowerCase()
const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
const preventDefault = (e) => {
  e.preventDefault()
}

const disableScrollModal = () => {
  window.addEventListener('touchmove', preventDefault, { passive: false })
}

const enableScrollModal = () => {
  window.removeEventListener('touchmove', preventDefault, { passive: false })
}
const getPostId = (id) => {
  emit('setCurrentPost', id)
}

const handleShowUser = async (id, userID, userType, myPost, is_deleted_in_30_days) => {
  if (userType === 'community_admin' || myPost || is_deleted_in_30_days === 2) {
    return
  }

  if (storeSaasType.value && isSaasTypePool(storeSaasType.value)) {
    return
  }

  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType })
  if (showModal.value) {
    await modal.value?.show()
  }
}

const ZoomImage = (image: string) => {
  disableScrollModal()
  store.dispatch(POST_STORE.ACTIONS.SET_ZOOM_IMAGE, image)
}

const openUrlAssignToImage = (url: string) => {
  const formattedUrl = /^(http|https):\/\//.test(url) ? url : `https://${url}`
  window.open(formattedUrl, '_blank')
}

const SeeMore = () => {
  fullContent.value = true
}

const getCommunitySiteContent = (content) => {
  if (!content) {
    return {}
  }
  // Create a temporary DOM element to parse the HTML content
  var tempDiv = document.createElement('div')
  tempDiv.innerHTML = purifyContent(content)

  // Traverse the original HTML and reconstruct up to the limit 100 characters
  var currentLength = 0
  var maxLength = 100
  var result = ''
  var reachedLimit = false

  var firstImageUrl = ''
  var checkGetImageSuccess = false
  let imageWrapClassName = ''
  let urlAssignToImage = ''
  var hasMoreContentThanLimit = false
  // Since image can be resize in editor
  // imageWidth and height need to be preserved if it has value
  let imageWidth = 0
  let imageHeight = 0

  // Get first img
  if (tempDiv.getElementsByTagName('img')?.length > 0) {
    const imageNode = tempDiv.getElementsByTagName('img')[0]
    firstImageUrl = imageNode.getAttribute('src')
    if (imageNode.hasAttribute('width')) {
      imageWidth = imageNode.getAttribute('width')
      imageHeight = imageNode.getAttribute('height')
    }
    let { nodeName } = imageNode.parentNode
    // In case of image has hyperlink attach to its,
    // then must recursively take style of <a>'s parent element
    if (nodeName === 'A') {
      urlAssignToImage = imageNode.parentNode.getAttribute('href')
    }
    imageWrapClassName = 'ql-align-center'
    checkGetImageSuccess = true
  }

  const traverse2 = (node) => {
    let openTag = ''
    let removeOpenTag = false
    if (node.nodeType !== Node.TEXT_NODE && node.tagName.toLowerCase() !== 'img') {
      openTag = '<' + node.tagName.toLowerCase()
      for (let i = 0; i < node.attributes.length; i++) {
        openTag += ' ' + node.attributes[i].name + '="' + node.attributes[i].value + '"'
      }
      openTag += '>'
      result += openTag
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const textContent = node.textContent
      const textContentLength = getUnicodeLength(textContent)

      if (textContentLength > 0 && currentLength === maxLength) {
        reachedLimit = true
        result += '...'
      } else {
        if (currentLength + textContentLength > maxLength) {
          const slice = sliceUnicode(textContent, maxLength - currentLength)
          result += escapeHtml(slice)
          if (!reachedLimit) {
            reachedLimit = true
            result += '...'
          }
          currentLength = maxLength
        } else {
          result += escapeHtml(textContent)
          currentLength += textContentLength
        }
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName.toLowerCase() === 'br') {
        if (currentLength >= maxLength) {
          const lastIdx = result.lastIndexOf(openTag)
          result = result.substring(0, lastIdx)
          removeOpenTag = true
        }
      } else {
        node.childNodes.forEach((child) => {
          if (!reachedLimit) {
            traverse2(child)
          }
        })
      }
    }

    if (node.nodeType !== Node.TEXT_NODE && node.tagName.toLowerCase() !== 'img') {
      if (!removeOpenTag) {
        if (node.tagName.toLowerCase() !== 'br') {
          result += '</' + node.tagName.toLowerCase() + '>'
        }
      }

      if ('h1|h2|li|p|blockquote|div'.includes(node.tagName.toLowerCase())) {
        currentLength += 1
        if (currentLength >= maxLength && !reachedLimit) {
          reachedLimit = true
          const { content: trimBottom } = editorTrimBottomOnlyNewLine(result, [EDITOR_EMPTY_TAG_REGEX])
          result = trimBottom
          result += '...'
        }
      }
    }
  }

  function traverse(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var textContent = node.textContent
      const textContentLength = getUnicodeLength(textContent)

      // Check if adding this text node would exceed maxLength
      if (currentLength + textContentLength > maxLength) {
        // Slice the text content up to the remaining allowed length
        result += sliceUnicode(textContent, maxLength - currentLength)
        if (!reachedLimit) {
          reachedLimit = true
          result += '...' // Only add ellipsis if truncation occurs
          hasMoreContentThanLimit = true
        }
        currentLength = maxLength
      } else {
        result += textContent
        currentLength += textContentLength
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Skip the img tag or stop if limit is reached
      if (node.tagName.toLowerCase() === 'img' || reachedLimit) {
        return
      }
      if (node.tagName.toLowerCase() === 'br') {
        if (currentLength >= maxLength) {
          return
        }
      }

      // Append opening tag
      result += '<' + node.tagName.toLowerCase()
      for (var i = 0; i < node.attributes.length; i++) {
        result += ' ' + node.attributes[i].name + '="' + node.attributes[i].value + '"'
      }
      result += '>'

      // Recursively process the child nodes
      for (var j = 0; j < node.childNodes.length; j++) {
        traverse(node.childNodes[j])
        if (currentLength >= maxLength) {
          if (!reachedLimit && hasMoreContentThanLimit) {
            reachedLimit = true
            result += '...' // Add ellipsis if content is truncated, not if exactly at limit
          }
          return // Stop processing further once limit is reached
        } else {
          currentLength += 1
        }
      }

      // Append closing tag
      if (node.tagName.toLowerCase() !== 'br') {
        result += '</' + node.tagName.toLowerCase() + '>'
      }
    }
  }

  // Start traversing from the actual child nodes of tempDiv to skip the div itself
  // tempDiv.childNodes.forEach((child) => traverse(child))
  traverse2(tempDiv)
  if (checkGetImageSuccess) {
    return {
      content: result,
      image_url: firstImageUrl,
      image_wrap_class_name: imageWrapClassName,
      url_assign_to_image: urlAssignToImage,
      image_size: {
        width: imageWidth,
        height: imageHeight,
      },
    }
  } else {
    return {
      content: result,
    }
  }
}

const showErrorToast = () => {
  toast.error({
    component: communitySitePostDeleted,
  })
}

// const DownloadPDF = (url_file: string) => {
//   var oReq = new XMLHttpRequest()
//   var URLToPDF = 'https://api.dev.yelloop.jp/api/v1/' + url_file

//   oReq.open('GET', URLToPDF, true)

//   oReq.responseType = 'blob'

//   oReq.onload = function () {
//     var file = new Blob([oReq.response], {
//       type: 'application/pdf',
//     })

//     saveAs(file, 'mypdffilename.pdf')
//   }

//   oReq.send()
// }

const showUrlInConfirmDialog = () => !isEmpty(props.post.site_name_1) || !isEmpty(props.post.site_url_1) || !isEmpty(props.post.site_name_2) || !isEmpty(props.post.site_url_2)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: ref,
      class: _normalizeClass(["bg-white shadow mb-5 rounded-4 p-3 p-lg-4", __props.post?.content_type == 5 ? 'community-site-post' : ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(Avatar, {
              is_deleted_in_30_days: __props.post?.is_deleted_in_30_days,
              user_image_url: __props.post.user_image_url,
              userType: __props.post.user_type,
              onClick: _cache[0] || (_cache[0] = () => handleShowUser(__props.post.community_id, __props.post.user_id, __props.post.user_type, __props.post?.my_post, __props.post?.is_deleted_in_30_days))
            }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([
            __props.post?.is_deleted_in_30_days !== 2 && !__props.post.my_post && __props.post?.user_type !== 'community_admin' && __props.post.is_profile_public && !_unref(isSaasTypePool)(_unref(storeSaasType))
              ? 'cursor-pointer'
              : '',
          ]),
            onClick: _cache[1] || (_cache[1] = () => handleShowUser(__props.post.community_id, __props.post.user_id, __props.post.user_type, __props.post?.my_post, __props.post?.is_deleted_in_30_days))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(UserAliasIcon, {
                userType: __props.post.user_type
              }, null, 8, ["userType"]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(__props.post.display_name), 1)
            ]),
            (__props.post.content_type === 5)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.post?.published_date ? _unref(ChangeTime)(__props.post?.published_date) : '-'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.post?.published_date ? _unref(ChangeTime)(__props.post?.published_date) : '-'), 1))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(FlagIcon, {
            favorite: __props.post.favorite,
            id: __props.post.id,
            isCSP: __props.post.content_type === 5,
            class: _normalizeClass(__props.post.content_type === 5 && __props.post.is_community_site_deleted ? 'disabled' : '')
          }, null, 8, ["favorite", "id", "isCSP", "class"]),
          (__props.post.my_post && __props.post?.content_type !== 5)
            ? (_openBlock(), _createBlock(Submenu, {
                key: 0,
                dataBs: [
            ['modal', '#editPost'],
            ['modal', '#deletePost'],
          ],
                content_type: __props.post.content_type,
                onGetPostId: _cache[2] || (_cache[2] = ($event: any) => (getPostId(__props.post.id)))
              }, null, 8, ["content_type"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "content border-bottom position-relative mb-4",
        ref: (_value, _refs) => {
          _refs['viewPost'] = _value
          viewPost.value = _value
        }
      }, [
        (__props.post.content_type !== 4)
          ? (_openBlock(), _createBlock(Category, {
              key: 0,
              content_type: __props.post.content_type
            }, null, 8, ["content_type"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (__props.post.content_type !== 4)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(__props.post.title), 1))
            : _createCommentVNode("", true),
          (__props.post?.content_type === 5 && _unref(communitySitePostContent)?.image_url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(communitySitePostContent)?.image_wrap_class_name)
                  }, [
                    _createElementVNode("img", {
                      src: _unref(communitySitePostContent)?.image_url,
                      alt: "post image",
                      class: "mb-4 cursor-pointer img-autopost",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(communitySitePostContent)?.url_assign_to_image ? openUrlAssignToImage(_unref(communitySitePostContent)?.url_assign_to_image) : ZoomImage($event.target.src))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": _unref(communitySitePostContent)?.url_assign_to_image ? '' : '#zoomImage',
                      width: _unref(communitySitePostContent)?.image_size?.width || null,
                      height: _unref(communitySitePostContent)?.image_size?.height || null
                    }, null, 8, _hoisted_12)
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            (__props.post?.content_type !== 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(TargetTag, {
                    data: __props.post?.content,
                    className: (__props.post.content_type === 4 ? 'fw-bold text-center  mt-5 mt-mb-3 fs-5 ' : '', fullContent.value || __props.post.content_type === 5 ? '' : 'p_content ')
                  }, null, 8, ["data", "className"]),
                  (seeMoreBtn.value > 72 && !fullContent.value && __props.post?.content_type !== 5)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "text-decoration-underline cursor-pointer",
                        onClick: SeeMore
                      }, _toDisplayString(_unref(translate)('seeMore')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass([' text-break break-spaces  real_height position-absolute', __props.post.content_type === 4 ? 'fw-bold text-center  mt-5 mt-mb-3 fs-5 ' : '']),
                    ref: (_value, _refs) => {
                      _refs['post_content'] = _value
                      post_content.value = _value
                    },
                    innerHTML: _unref(purifyContent)(__props.post?.content)
                  }, null, 10, _hoisted_15)
                ]))
              : _createCommentVNode("", true),
            (__props.post?.content_type === 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", {
                      id: `post-content-container-${divId.value}`,
                      class: "ql-editor only-view-editor no-padding"
                    }, [
                      _createElementVNode("div", {
                        innerHTML: _unref(communitySitePostContent)?.content
                      }, null, 8, _hoisted_19)
                    ], 8, _hoisted_18)
                  ])
                ]))
              : _createCommentVNode("", true),
            (showUrlInConfirmDialog())
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(UrlDisplay, {
                    "site-url": __props.post.site_url_1,
                    "site-name": __props.post.site_name_1
                  }, null, 8, ["site-url", "site-name"]),
                  _createVNode(UrlDisplay, {
                    "site-url": __props.post.site_url_2,
                    "site-name": __props.post.site_name_2
                  }, null, 8, ["site-url", "site-name"])
                ]))
              : _createCommentVNode("", true),
            (__props.post.content_type === 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  (!__props.post.my_post)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "text-decoration-none text-black fs-7 fw-bold rounded-pill px-3 px-lg-5 text-center py-2 shadow border button-router-link cursor-pointer",
                        onClick: _cache[4] || (_cache[4] = () => handleShowUser(__props.post.community_id, __props.post.user_id, __props.post.user_type))
                      }, _toDisplayString(__props.post.display_name) + "さんのプロフィール", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["text-center", !showUrlInConfirmDialog() ? 'mt-4' : ''])
          }, [
            (__props.post.image_url && __props.post?.content_type !== 5)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(addPostParams)(__props.post.image_url, __props.post.content_type),
                  alt: "post image",
                  class: "img-url mb-4 cursor-pointer",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (ZoomImage($event.target.src))),
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#zoomImage"
                }, null, 8, _hoisted_23))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_24, [
            (__props.post?.content_type === 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (__props.post.is_community_site_deleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: "text-button-container",
                          onClick: showErrorToast
                        }, _hoisted_29)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_router_link, {
                          to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/community_site_posts_details/${__props.post.id}`,
                          class: "text-link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                ]))
              : _createCommentVNode("", true),
            (__props.post.content_type !== 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.post.tags, (tag) => {
                      return (_openBlock(), _createBlock(HashTag, {
                        key: tag.id,
                        tag: tag,
                        searchable: true,
                        class: "me-2 mb-2"
                      }, null, 8, ["tag"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(LikeButton, {
                    class: _normalizeClass(["me-2", __props.post.content_type === 5 && __props.post.is_community_site_deleted ? 'disabled' : '']),
                    count: __props.post.like_count,
                    like: __props.post.like,
                    id: __props.post.id,
                    type: 'like',
                    handleLikeOrInterest: () => __props.handleLikeOrInterest('like', __props.post),
                    my_post: __props.post?.my_post,
                    available: __props.post?.available,
                    is_deleted_in_30_days: __props.post?.is_deleted_in_30_days,
                    loadingLike: __props.loadingLike,
                    user_type: __props.post?.user_type,
                    isCSP: __props.post.content_type === 5
                  }, null, 8, ["class", "count", "like", "id", "handleLikeOrInterest", "my_post", "available", "is_deleted_in_30_days", "loadingLike", "user_type", "isCSP"]),
                  (__props.post.content_type !== 4 && __props.post?.content_type !== 1 && __props.post?.content_type !== 5)
                    ? (_openBlock(), _createBlock(LikeButton, {
                        key: 0,
                        count: __props.post.interest_count,
                        interest: __props.post.interest,
                        id: __props.post.id,
                        type: 'interest',
                        handleLikeOrInterest: () => __props.handleInterestClick(__props.post),
                        my_post: __props.post?.my_post,
                        available: __props.post?.available,
                        is_deleted_in_30_days: __props.post?.is_deleted_in_30_days,
                        loadingLike: __props.loadingLike,
                        user_type: __props.post?.user_type,
                        "post-content-type": __props.post?.content_type
                      }, null, 8, ["count", "interest", "id", "handleLikeOrInterest", "my_post", "available", "is_deleted_in_30_days", "loadingLike", "user_type", "post-content-type"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createVNode(LikeButton, {
                    class: _normalizeClass(["me-2", __props.post.content_type === 5 && __props.post.is_community_site_deleted ? 'disabled' : '']),
                    count: __props.post.like_count,
                    like: __props.post.like,
                    id: __props.post.id,
                    type: 'like',
                    handleLikeOrInterest: () => __props.handleLikeOrInterest('like', __props.post),
                    available: __props.post?.available,
                    my_post: __props.post?.my_post,
                    is_deleted_in_30_days: __props.post?.is_deleted_in_30_days,
                    loadingLike: __props.loadingLike,
                    user_type: __props.post?.user_type,
                    isCSP: __props.post.content_type === 5
                  }, null, 8, ["class", "count", "like", "id", "handleLikeOrInterest", "available", "my_post", "is_deleted_in_30_days", "loadingLike", "user_type", "isCSP"]),
                  (__props.post.content_type !== 4 && __props.post?.content_type !== 1 && __props.post?.content_type !== 5)
                    ? (_openBlock(), _createBlock(LikeButton, {
                        key: 0,
                        count: __props.post.interest_count,
                        interest: __props.post.interest,
                        id: __props.post.id,
                        type: 'interest',
                        handleLikeOrInterest: () => __props.handleInterestClick(__props.post),
                        my_post: __props.post?.my_post,
                        available: __props.post?.available,
                        is_deleted_in_30_days: __props.post?.is_deleted_in_30_days,
                        loadingLike: __props.loadingLike,
                        user_type: __props.post?.user_type,
                        "post-content-type": __props.post?.content_type
                      }, null, 8, ["count", "interest", "id", "handleLikeOrInterest", "my_post", "available", "is_deleted_in_30_days", "loadingLike", "user_type", "post-content-type"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (__props.post.file_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("p", _hoisted_39, _toDisplayString(__props.post.file_url.split('/').slice(-1)[0]), 1)
                  ]),
                  _createVNode(PostFileDownload, {
                    className: "rounded-circle cursor-pointer",
                    communityId: __props.post.community_id,
                    postId: __props.post.id,
                    fileDownloadName: __props.post.file_url.split('/').slice(-1)[0]
                  }, null, 8, ["communityId", "postId", "fileDownloadName"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512),
      (!_unref(isSaasTypePool)(_unref(storeSaasType)))
        ? (_openBlock(), _createBlock(UserComments, {
            key: 0,
            comments: __props.post.comments,
            comment_count: __props.post.comment_count,
            postId: __props.post.id,
            mention_users: _unref(listUserShow),
            onSetCommentData: setCommentData,
            onShowDeleteCommentModal: showDeleteCommentModal,
            isNotLoadingPostSkeleton: __props.isNotLoadingPostSkeleton,
            isCSP: __props.post.content_type === 5,
            isCSPDeleted: __props.post?.content_type === 5 && __props.post?.is_community_site_deleted,
            id_comment: __props.id_comment
          }, null, 8, ["comments", "comment_count", "postId", "mention_users", "isNotLoadingPostSkeleton", "isCSP", "isCSPDeleted", "id_comment"]))
        : _createCommentVNode("", true),
      (!_unref(isSaasTypePool)(_unref(storeSaasType)))
        ? (_openBlock(), _createBlock(Comment, {
            key: 1,
            post: __props.post,
            admin: false,
            users: _unref(mentionUsers),
            isCSP: __props.post.content_type === 5,
            titleMention: _unref(translate)('titleMentionPostDetail')
          }, null, 8, ["post", "users", "isCSP", "titleMention"]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser),
    _createVNode(ModalZoomImage)
  ], 64))
}
}

})